import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { afterLogin } from "@/lib/authDestination";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", null, { headers: { "X-Session-ID": sid } });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/");
        navigate(afterLogin(res.data), { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground animate-pulse">
        Authenticating
      </p>
    </div>
  );
}
